import Vue from 'vue'

import helloWorld from './helloWorld'
import getMainTest from './getMainTest'

Vue.mixin(helloWorld)
Vue.mixin(getMainTest)
